<template>
    <div id="dashboard-analytics">
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <vx-card :loading="comissoes.loading" title="Comissões">
                    <template slot="actions">
                        <feather-icon @click="$router.push('/comissoes')" icon="ArrowUpRightIcon"
                                      svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </template>
                    <div class="p-6 pb-0" slot="no-body">
                        <div class="flex">
                            <div class="mr-6">
                                <p class="mb-1 font-semibold">Mês Atual</p>
                                <p class="text-3xl text-success"><sup class="text-base mr-1">R$</sup>{{comissoes.mes.atual}}
                                </p>
                            </div>
                            <div>
                                <p class="mb-1 font-semibold">Mês Anterior</p>
                                <p class="text-3xl"><sup class="text-base mr-1">R$</sup>{{comissoes.mes.anterior}}</p>
                            </div>
                        </div>
                        <LineChart :options="comissoes.chartData"/>
                    </div>
                </vx-card>
            </div>

            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                <vx-card :loading="tickets.loading" title="Desenvolvimento">
                    <template slot="actions">
                        <feather-icon @click="$router.push('/tickets')" icon="ArrowUpRightIcon"
                                      svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </template>

                    <div slot="no-body">
                        <div class="vx-row text-center">
                            <div class="vx-col sm:w-1/5 w-full flex flex-col justify-between mb-4">
                                <div class="ml-6 mt-6">
                                    <h1 class="font-bold text-5xl">{{tickets.total}}</h1>
                                    <small>Tickets</small>
                                </div>
                            </div>
                            <div class="vx-col sm:w-4/5 w-full justify-center mx-auto">
                                <PieChart :options="tickets.chartData" style="width:100%;height:255px"/>
                            </div>
                        </div>
                        <div class="flex flex-row justify-between px-8 pb-4">
                            <p class="text-center"><span class="block">Resolvidos</span><span class="text-4xl">{{tickets.resolvidos}}</span>
                            </p>
                            <p class="text-center"><span class="block">Fechados</span><span class="text-4xl">{{tickets.fechados}}</span>
                            </p>
                            <p class="text-center"><span class="block">Desenvolvimento</span><span class="text-4xl">{{tickets.abertos}}</span>
                            </p>

                        </div>
                    </div>
                </vx-card>
            </div>

            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                <vx-card :loading="map.loading" title="Clientes">
                    <div class="p-6 pb-0" slot="no-body">
                        <div class="flex flex-row justify-between pb-6">
                            <GmapMap
                                    :center="map.center"
                                    :zoom="7"
                                    map-type-id="terrain"
                                    style="width: 100%; height: 300px"
                            >
                                <GmapMarker
                                        :key="index"
                                        v-for="(m, index) in map.markers"
                                        :position="m.position"
                                        clickable
                                        :draggable="false"
                                        @click="m.info = true"
                                >
                                    <GmapInfoWindow :opened="m.info && !!m.nome">
                                        <div class="mapaInfoWindow">
                                            <div class="nome">{{m.nome}}</div>
                                            <div v-if="m.celular" class="celular">{{m.celular}}</div>
                                            <div v-if="m.telefone" class="telefone">{{m.telefone}}</div>
                                            <div v-if="m.email" class="email">{{m.email}}</div>
                                        </div>
                                    </GmapInfoWindow>
                                </GmapMarker>
                            </GmapMap>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
    import {moment} from '@/helpers/moment';
    import accounting from 'accounting';
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'Estatisticas',
        data() {
            return {
                comissoes: {
                    loading: true,
                    mes: {
                        atual: 0,
                        anterior: 0,
                    },
                    chartData: {},
                },
                tickets: {
                    loading: true,
                    total: 0,
                    resolvidos: 0,
                    fechados: 0,
                    abertos: 0,
                    chartData: {}
                },
                map: {
                    loading: true,
                    center: {lat: -22.22, lng: -54.81},
                    markers: []
                }
            }
        },
        computed: {
            ...mapGetters(['dashboard', 'idUser', 'currentUser']),
        },
        methods: {
            ...mapActions(['updateDashboard']),
            async getComissoes() {
                const {data} = await this.$axios.get('comissoes/ultimos12Meses');
                const meses = Object.keys(data).map(key => moment(key, "YYYY_MM").format("MM/YYYY"));
                const comissoes = Object.values(data).map(comissao => comissao.total_comissao - comissao.taxas);

                const min = Math.trunc(Math.min(...comissoes)) - 500;
                const start = min > 0 ? min : 0;

                const lastIndex = comissoes.length - 1;

                const mes = {
                    atual: accounting.formatNumber(comissoes[lastIndex], 2, ".", ","),
                    anterior: accounting.formatNumber(comissoes[lastIndex - 1] || 0, 2, ".", ","),
                };

                this.fillComissoes({meses, comissoes, start, mes});

                this.updateDashboard({
                    date: new Date(),
                    idUser: this.idUser,
                    comissoes: {meses, comissoes, start, mes}
                });
            },
            fillComissoes({meses, comissoes, start, mes}) {

                this.comissoes.mes = mes;
                this.comissoes.loading = false;

                this.comissoes.chartData = {
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        formatter: ([param]) => `${param.name}<br>${param.marker} R$ ${accounting.formatNumber(param.value, 2, ".", ",")}`,
                        axisPointer: {
                            type: 'cross',
                            lineStyle: {
                                type: 'dashed'
                            },
                            crossStyle: {
                                width: 0
                            }
                        },
                        borderWidth: 0.1,
                        borderColor: '#ccc',
                        backgroundColor: '#fff',
                        textStyle: {
                            color: '#787878'
                        }
                    },
                    toolbox: {
                        show: true,
                        showTitle: false,
                        feature: {
                            mark: {show: true},
                            magicType: {show: true, type: ['line', 'bar']},
                            saveAsImage: {show: true}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: meses,
                        boundaryGap: false,
                        silent: false,
                        axisLine: {show: false, onZero: true},
                        splitLine: {show: false},
                        splitArea: {show: false},
                        axisLabel: {color: '#ccc'},
                    },
                    yAxis: {
                        type: 'value',
                        min: start,
                        axisLine: {show: false, onZero: true},
                        axisLabel: {
                            color: '#ccc', formatter: param => param
                        },
                    },
                    grid: {
                        left: 50,
                        right: 10
                    },
                    label: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value && param.seriesData.length === 0 ? `R$ ${accounting.formatNumber(param.value, 2, ".", ",")}` : param.value,
                    },
                    series: [{
                        label: {
                            position: 'top',
                            show: true,
                            formatter: (param) => param.value ? `R$ ${accounting.formatNumber(param.value, 2, ".", ",")}` : '',
                        },
                        data: comissoes,
                        type: 'line',
                        smooth: true,
                        symbolSize: 5,
                        lineStyle: {
                            width: 4,
                            shadowColor: '#eee',
                            shadowOffsetY: 20,
                            // Linear gradient. First four parameters are x0, y0, x2, and y2, each ranged from 0 to 1, standing for percentage in the bounding box. If global is `true`, then the first four parameters are in absolute pixel positions.
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 1,
                                x2: 0,
                                y2: 0,
                                colorStops: [{
                                    offset: 0, color: '#4caf50' // color at 0% position
                                }, {
                                    offset: 1, color: '#009688' // color at 100% position
                                }],
                                global: false // false by default
                            }
                        }
                    }]
                };
            },
            async getTickets() {
                const {data} = await this.$axios.get(`stats/tickets/totals`);
                if (data.total > 0) {
                    const total = data.total;
                    const resolvidos = data.status.resolvidos;
                    const fechados = data.status.fechados;
                    const abertos = data.status.desenvolvimento;

                    const colors = {
                        'Bug': '#F8456B',
                        'Melhoria': '#ffeb3b',
                        'Importação': '#607d8b',
                        'MVP': '#3f51b5',
                        'Solicitação de Serviço': '#2196f3',
                    };

                    let tipos = Object.keys(data.tipos).map(key => ({
                        name: key,
                        value: data.tipos[key],
                        itemStyle: {
                            color: colors[key] || null
                        }
                    }));

                    this.fillTickets({total, resolvidos, fechados, abertos, tipos});
                } else {
                    this.updateDashboard({
                        date: new Date(),
                        idUser: this.idUser,
                        tickets: {total: 0, resolvidos: 0, fechados: 0, abertos: 0, tipos: []}
                    });
                    this.fillTickets({total: 0, resolvidos: 0, fechados: 0, abertos: 0, tipos: []});
                }
            },
            fillTickets({total, resolvidos, fechados, abertos, tipos: echartData}) {
                const scale = 1;
                this.tickets = {
                    loading: false,
                    total,
                    resolvidos,
                    fechados,
                    abertos,
                    chartData: {
                        tooltip: {show: false},
                        legend: {show: false},
                        series: [{
                            name: 'Tickets',
                            type: 'pie',
                            radius: ['70%', '90%'],
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'center',
                                    backgroundColor: '#fff',
                                    formatter: function (params) {
                                        const percent = ((params.value / total) * 100).toFixed(1);
                                        return '{title|' + params.name + '}\n{yellow|' + params.value + '}\n{blue|' + percent + '%}';
                                    },
                                    rich: {
                                        title: {
                                            color: "#000",
                                            align: 'center',
                                            fontSize: 14 * scale,
                                            width: 160,
                                        },
                                        yellow: {
                                            color: "#ffc72b",
                                            fontSize: 30 * scale,
                                            padding: [5, 4],
                                            align: 'center'
                                        },
                                        total: {
                                            color: "#ffc72b",
                                            fontSize: 40 * scale,
                                            align: 'center'
                                        },
                                        blue: {
                                            color: '#49dff0',
                                            fontSize: 16 * scale,
                                            align: 'center'
                                        },
                                    }
                                },
                                emphasis: {show: true},
                            },
                            data: echartData
                        }]
                    }
                };
            },
            async getClientes() {
                const {data: {data}} = await this.$axios.get('company/q?');
                const clientes = data.filter(({company}) => !!company.address.latitude && !!company.address.longitude)
                    .map(({company}) => ({
                        nome: company.fantasy_name,
                        email: company.contact.email,
                        celular: company.contact.phone,
                        telefone: company.contact.telphone,
                        info: false,
                        position: {
                            lat: parseFloat(company.address.latitude),
                            lng: parseFloat(company.address.longitude)
                        }
                    }));

                this.updateDashboard({
                    date: new Date(),
                    idUser: this.idUser,
                    map: {clientes}
                });

                this.fillMap({clientes});
            },
            fillMap({clientes}) {

                const {end_latitude, end_longitude} = this.currentUser;

                this.map.center = {
                    lat: parseFloat(end_latitude),
                    lng: parseFloat(end_longitude),
                };

                this.map.markers = JSON.parse(JSON.stringify(clientes));
                this.map.loading = false;
            }
        },
        created() {
            const {idUser, date, comissoes, tickets, map} = this.dashboard;
            
            this.getComissoes();
            this.getClientes();
            this.getTickets();
                
        },
        components: {
            LineChart: () => import('@/components/charts/LineChart.vue'),
            PieChart: () => import('@/components/charts/PieChart.vue'),
            ChangeTimeDurationDropdown: () => import('@/components/ChangeTimeDurationDropdown.vue'),
            VueApexCharts: () => import('vue-apexcharts')
        },
    }
</script>

<style scoped>
    .mapaInfoWindow {
        width: 220px;
    }

    .mapaInfoWindow .nome {
        width: 100%;
        float: left;
        padding: 5px;
        font-size: 16px;
        font-weight: bold;
    }

    .mapaInfoWindow .celular, .mapaInfoWindow .telefone {
        width: 50%;
        float: left;
        padding: 5px;
        font-size: 13px;
    }

    .mapaInfoWindow .email {
        width: 100%;
        float: left;
        padding: 5px;
        font-size: 13px;
    }
</style>
